var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartsIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02975 3.3437C10.9834 2.88543 13.0166 2.88543 14.9703 3.3437C17.7916 4.00549 19.9945 6.20842 20.6563 9.02975C21.1146 10.9834 21.1146 13.0166 20.6563 14.9703C19.9945 17.7916 17.7916 19.9945 14.9703 20.6563C13.0166 21.1146 10.9834 21.1146 9.02975 20.6563C6.20842 19.9945 4.0055 17.7916 3.3437 14.9703C2.88543 13.0166 2.88543 10.9834 3.3437 9.02975C4.0055 6.20841 6.20842 4.00549 9.02975 3.3437ZM12.5743 9.12815C12.5743 8.81093 12.3172 8.55377 12 8.55377C11.6828 8.55377 11.4256 8.81093 11.4256 9.12815L11.4256 13.9146C11.4256 14.2318 11.6828 14.4889 12 14.4889C12.3172 14.4889 12.5743 14.2318 12.5743 13.9146V9.12815ZM9.70249 11.0427C9.70249 10.7255 9.44533 10.4683 9.12812 10.4683C8.8109 10.4683 8.55374 10.7255 8.55374 11.0427V14.8719C8.55374 15.1891 8.8109 15.4462 9.12812 15.4462C9.44533 15.4462 9.70249 15.1891 9.70249 14.8719V11.0427ZM15.4462 12C15.4462 11.6828 15.1891 11.4256 14.8718 11.4256C14.5546 11.4256 14.2975 11.6828 14.2975 12V14.8719C14.2975 15.1891 14.5546 15.4462 14.8718 15.4462C15.1891 15.4462 15.4462 15.1891 15.4462 14.8719V12Z",
    fill: "#0E9AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartsIconFilled);
export default __webpack_public_path__ + "static/media/chartsIconFilled.6950b54c492a5083909063d5ea1467eb.svg";
export { ForwardRef as ReactComponent };